import "core-js/modules/es.number.constructor.js";
import StandardTableVue from '@/components/table/StandardTable.vue';
import { spcialNotifyIsopen } from '@/services/systemsetting';
export default {
  components: {
    StandardTableVue: StandardTableVue
  },
  i18n: require('../../i18n-basucSettings'),
  props: {
    settingVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '800px'
    },
    notiftOpen: {
      type: Number,
      default: null
    },
    data: {
      type: Array,
      default: function _default() {
        [];
      }
    },
    showHtml: {
      type: Boolean,
      default: false
    },
    html: {
      type: String,
      default: ''
    },
    columnsNotify: {
      type: Array,
      default: function _default() {
        [];
      }
    },
    notiType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {
    confirm: function confirm(row) {
      this.$emit('SettingOk', row);
      // this.$message.success(this.$t('switchSuccess'));
    },
    cancel: function cancel() {
      // this.$message.error(this.$t('switchError'));
    } // changeOpen(e) {
    //   this.$emit('changeNotiftOpen', e.target.value)
    // },
  }
};